/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'ai-mate.agent-message.error': 'チャットを再読み込み',
  'ai-mate.agent-message.error.aup-link-text': '利用規定',
  'ai-mate.agent-message.error.aup-one': 'そのプロンプトには応答できません。',
  'ai-mate.agent-message.error.aup-two':
    'プロンプトがアトラシアンの{link}に準拠していない可能性があります。別のプロンプトをお試しください。',
  'ai-mate.agent-message.error.copy-trace-id': 'トレース ID をコピー',
  'ai-mate.agent-message.error.network-error': 'ネットワークに問題が発生したようです。',
  'ai-mate.agent-message.error.resend': 'メッセージを再送信',
  'ai-mate.agent-message.error.trace-id': 'トレース ID: {traceId}',
  'ai-mate.browse-agents-view.close-button': 'エージェント ビューを閉じる',
  'ai-mate.browse-agents-view.header-title': 'エージェントを参照する',
  'ai-mate.chat-header-agent-menu.browse-agents': 'エージェントを見る',
  'ai-mate.chat-header-agent-menu.chat-with-rovo': 'Rovo とチャット',
  'ai-mate.chat-header-agent-menu.copy-agent-link-clicked-tooltip': 'リンクがコピーされました!',
  'ai-mate.chat-header-agent-menu.copy-link': 'リンクをコピー',
  'ai-mate.chat-header-agent-menu.create-agent': 'エージェントを作成',
  'ai-mate.chat-header-agent-menu.create-button-disabled-tooltip': 'このサイトでエージェントを作成する権限がありません',
  'ai-mate.chat-header-agent-menu.edit-agent': 'エージェントを編集',
  'ai-mate.chat-header-agent-menu.favorite-agent': 'お気に入り',
  'ai-mate.chat-header-agent-menu.search-placeholder': 'エージェントを検索',
  'ai-mate.chat-header-agent-menu.switch-agent': '別のエージェントに切り替え',
  'ai-mate.chat-header-agent-menu.view-agent-profile': 'エージェント プロファイルを表示',
  'ai-mate.chat-header.browse-agents-title': 'エージェントを参照する',
  'ai-mate.chat-header.chat-history-title': 'チャット履歴',
  'ai-mate.chat-header.default-agent-name': 'Rovo',
  'ai-mate.chat-history.conversationLimit':
    '過去のチャットをお探しですか? AI がスムーズに動作するように、チャット履歴は 30 日経過すると消去されます。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1': '最近私が投稿した Confluence ページを教えてください。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': '私に割り当てられた Jira チケットをすべて検索してください。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': '出張ポリシーとは何ですか?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4':
    'マーケティング キャンペーン向け Confluence ページの下書きを作ってください。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5':
    'プロジェクト タイムラインはどのようにして作成すればよいですか?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6': '見込み顧客に送るフォローアップのメールを書いてください。',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-7': '次は何に取り組めばよいですか?',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-1': '`ユーザー` が作成したプル リクエストを教えてください。',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-2': '現在の Jira スプリントでオープンなプル リクエストは何ですか?',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-3': '`Jira 作業項目` はデプロイされていますか?',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-4': 'この "プル リクエスト" のレビュアーは誰ですか?',
  'ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-1': 'このプル リクエストを要約してください。',
  'ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-2': 'コードの変更内容を説明してください。',
  'ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-3':
    'このプル リクエストに対するコメントを要約してください。',
  'ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-1': 'このファイルについて説明してください。',
  'ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-2':
    '"ユーザー" が作成したプル リクエストを教えてください。',
  'ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-3':
    'これらのファイルはどの API やモジュールと連携していますか?',
  'ai-mate.chat-history.empty-state.browse-agents-button-text': 'エージェントを参照',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': 'Rovo エージェントとチャットする',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': 'このスペースについて',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': 'このスペースに関するインサイト',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': 'スペースの提案',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1':
    '私が書き込んだページに何か新しいアクティビティはありますか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10':
    '私が公開したページに `ユーザー` はコメントしていますか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11': '`ページ` の重要ポイントは何ですか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-12': '次に着手すべき作業はどれですか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2': '私をメンションしている新規コメントはありますか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3': 'このスペースで最近公開されたページを要約してください。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4': '先週以降に私がページに投稿した内容を要約してください。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5':
    'この `ページ` の内容を技術的にあまり難しくない表現で書き直してくれませんか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6':
    'プロジェクト管理用のゲーム プラン テンプレートを作成してください。',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7':
    '顧客がよく遭遇する問題について私たちはどのような調査を行っていますか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8': '今週私のチームの誰かが新しいページを公開しましたか?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9': '今週 `ユーザー` は新しいページを公開しましたか?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1': 'このページの文章を改善してもらえますか?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2':
    'このページのエグゼクティブ サマリーを作成してください。',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3': '他の関連ページへのリンクを教えてください。',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-4': '次に着手すべき作業はどれですか?',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': 'このページについて',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': 'このページのその他の情報',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': 'ページの提案',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': 'これを見ている私に要約してください。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': 'このページのコメントを要約してください。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3': 'このページについて初心者向けに説明してください。',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4': 'このページを書いたのはどのチームの誰ですか?',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5': '過去 1 週間でこのページに何か変更はありましたか?',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-6': '次は何に取り組めばよいですか?',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': 'このホワイトボードについて',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': 'このホワイトボードの詳細',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': 'このホワイトボードのインサイト',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': 'これを見ている私に要約してください。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-4': '次は何に取り組めばよいですか?',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2':
    'ここで確認できるパターンまたは傾向があればハイライトしてください。',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3':
    'このホワイトボードでキャプチャされた主要なアクション アイテムまたは決定事項があれば特定してください。',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': '生産性の向上',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': '内容の下書き',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': '情報の検索',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': 'ユーザーの検索',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': '疑問の解決',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': '生産性の測定',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': '内容の言い換え',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': '最新情報の入手',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': '内容の要約',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>作成者</text>: {creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': '{userName} さん、こんにちは',
  'ai-mate.chat-history.empty-state.intro-text-link-text': 'Rovo チャットと Rovo エージェントを使ってみましょう',
  'ai-mate.chat-history.empty-state.intro-text-subheadline': '会話のきっかけから 1 つを選ぶか、何か質問してください。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': '今週更新された Jira 作業項目を探してください',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh':
    '今週更新された Jira 作業項目を探してください',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': '優先度が最も高い Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh':
    '優先度が最も高い Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3':
    '私をメンションしているコメントがある Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh':
    '私をメンションしているコメントがある Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': '"Jira 作業項目" のコメントを要約してください。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh':
    '`Jira 作業項目` のコメントを要約してください。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': 'ユーザー ストーリー用の説明テンプレートを作成してください。',
  'ai-mate.chat-history.empty-state.jira-home-prompt-6': '次は何に取り組めばよいですか?',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': 'この作業項目について',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': 'この作業項目について',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': 'この作業項目のその他の情報',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh': 'この作業項目のその他の情報',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': 'この作業項目に関するインサイト',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': 'この作業項目に関するインサイト',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': '作業項目の提案',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': '作業項目の提案',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': 'この作業項目に似た Jira 作業項目はありますか?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh':
    'この作業項目に似た Jira 作業項目はありますか?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': 'この説明文を改善するにはどうすればよいですか?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3':
    'この作業項目にはどのようなラベルを追加すればよいですか?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh':
    'この作業項目にはどのようなラベルを追加すればよいですか?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-4': '次に着手すべき作業はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': 'このプロジェクトについて',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': 'このプロジェクトに関するインサイト',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': 'このプロジェクトのその他の情報',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': 'プロジェクトの提案',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': 'しばらく着手されていない作業はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': '類似する Jira 作業項目を見つけてグループ化してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh':
    '類似する Jira 作業項目を見つけてグループ化してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11':
    '親作業項目に結び付けられていない Jira 作業項目はありますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    '親作業項目に結び付けられていない Jira 作業項目はありますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12':
    '"Jira 作業項目" の説明をベストプラクティスに合わせて書き直してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    '`Jira 作業項目` の説明をベストプラクティスに合わせて書き直してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': '"Jira 作業項目" のコメントを要約してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh':
    '`Jira 作業項目` のコメントを要約してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14':
    'ユーザー ストーリー用の説明テンプレートを作成してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh':
    'ユーザー ストーリー用の説明テンプレートを作成してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-15': '次は何に取り組めばよいですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': 'ブロックされている Jira 作業項目はありますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh':
    'ブロックされている Jira 作業項目はありますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3':
    '現在 "進行中" の Jira 作業項目をリストして、担当者別にグループ化してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    '現在 "進行中" の Jira 作業項目をリストして、担当者別にグループ化してください。',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': '"ユーザー" には何件の作業項目が割り当てられていますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh':
    '`ユーザー` には何件の作業項目が割り当てられていますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5':
    '"ユーザー" はこのスプリントの Jira 作業項目にコメントしていますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    '`ユーザー` はこのスプリントの Jira 作業項目にコメントしていますか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': '未割り当ての Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh':
    '未割り当ての Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7': 'オープンの状態が最も長い Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh':
    'オープンの状態が最も長い Jira 作業項目はどれですか?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': 'タスクが最も多いのは誰ですか?',
  'ai-mate.chat-history.empty-state.message':
    '答えを見つけたり、新しいアイデアを生み出したり、日々の仕事を効率化したりできます。',
  'ai-mate.chat-history.empty-state.suggestion1': '自分の作業項目の中で期限切れになっているものはありますか?',
  'ai-mate.chat-history.empty-state.suggestion2': '次は何に取り組めばよいですか?',
  'ai-mate.chat-history.empty-state.suggestion3': '私の今週の作業のまとめを書いてください',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': '提案',
  'ai-mate.chat-history.loading-state.rovo-is-thinking': '{name} が考え中',
  'ai-mate.chat-history.message-post-research.title': '調査が完了しました',
  'ai-mate.chat-history.message-pre-research.title': '調査計画を作成しています',
  'ai-mate.chat-history.message-research-notification-button-text': '完了したら通知を受け取る',
  'ai-mate.chat-history.message-research-notification-confirmation-label-text': '完了しましたらお知らせします',
  'ai-mate.chat-history.message-research-notification-text':
    '詳細調査には数分かかる場合がありますが、価値のある結果が得られます。その間、別の作業をすることができますが、このチャット ウィンドウを開いたままにしてください。',
  'ai-mate.chat-history.message-research-refresh.research-step-title-placeholder': '関連情報を検索しています...',
  'ai-mate.chat-history.message-research-refresh.rovo-is-thinking': 'Rovo が考え中',
  'ai-mate.chat-history.message-research-refresh.steps': '手順 {count}/{count}',
  'ai-mate.chat-history.message-research.research-completed-notification-body':
    '調査が完了し、閲覧できるようになりました。',
  'ai-mate.chat-history.message-research.research-completed-notification-title': 'Rovo チャットが調査を完了しました',
  'ai-mate.chat-history.message-research.research-expandable.collapse': '折りたたむ',
  'ai-mate.chat-history.message-research.research-expandable.expand': '展開',
  'ai-mate.chat-history.message-research.research-step-title-placeholder': '関連情報を検索しています...',
  'ai-mate.chat-history.message-research.sources-title': '{count, plural, other {{count} 件のソース}}',
  'ai-mate.chat-history.message-research.step-loaded-icon-label': 'ステップを読み込みました',
  'ai-mate.chat-history.message-research.step-loading-icon-label': 'ステップを読み込んでいます',
  'ai-mate.chat-history.message-research.title.v2': '調査アクティビティを表示する',
  'ai-mate.chat-history.message-research.view-sources-button-label': '{count, plural, other {{count} 件のソース}}',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': 'キャンセル',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': '確定',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button':
    'このアクションを完了する際に問題が発生しました',
  'ai-mate.chat-input.actions-button.label': '要素を挿入',
  'ai-mate.chat-input.add-a-link-button.label': 'リンクを追加',
  'ai-mate.chat-input.chat-input-assistive-label': 'プロンプトを書いて開始',
  'ai-mate.chat-input.chat-input-continue-assistive-label': 'フォローアップを依頼',
  'ai-mate.chat-input.chat-input-continue-conversation-placeholder': '知りたいことや次にしたいことを説明してください',
  'ai-mate.chat-input.chat-input-default-placeholder':
    'プロンプトを入力するか、誰かを @メンションするか、「/」を使用してアクションを実行',
  'ai-mate.chat-input.deep-research-button.label': '詳細調査',
  'ai-mate.chat-input.deleted-agent-icon-label': 'エージェントが削除されました',
  'ai-mate.chat-input.deleted-agent-start-new-chat': '新規チャットを開始',
  'ai-mate.chat-input.deleted-agent-warning': 'このエージェントは削除されました。',
  'ai-mate.chat-input.dr.disabled.tooltip': '現在、エージェントは詳細調査を使用できません。',
  'ai-mate.chat-input.drag-and-drop-message':
    'より良い結果を得るには、ドラッグ アンド ドロップでコンテキストを追加してください',
  'ai-mate.chat-input.file-close-icon-label': 'ファイルを削除',
  'ai-mate.chat-input.link-type-ahead-button.label': 'リンクを追加',
  'ai-mate.chat-input.mention-someone-button.label': 'ユーザーまたはチームをメンション',
  'ai-mate.chat-input.mention-type-ahead-button.label': 'ユーザーをメンション',
  'ai-mate.chat-input.notifications-enabled': '通知が有効化されました',
  'ai-mate.chat-input.notifications-enabled-body': '別のタブで作業を続行できます。調査が完了したら通知が届きます。',
  'ai-mate.chat-input.notifications-enabled-button': '通知を有効化',
  'ai-mate.chat-input.notifications-enabled-notification-content': '詳細調査のクエリが完了すると通知が届きます。',
  'ai-mate.chat-input.notifications-enabled-notification-title': '通知が有効化されました',
  'ai-mate.chat-input.notifications-not-enabled': '通知が有効化されていません',
  'ai-mate.chat-input.notifications-not-enabled-body':
    '詳細調査は高度な機能ですが、完了までに少し時間がかかる場合があります。通知を有効化すると、別のタブで作業を続行できます。調査が完了したら通知が届きます。',
  'ai-mate.chat-input.open-chat-input-buttons-label': 'チャット入力を開くボタン',
  'ai-mate.chat-input.search.disabled.tooltip': '現在、エージェントは Web 検索を使用できません。',
  'ai-mate.chat-input.send-button.label': '送信',
  'ai-mate.chat-input.stop-generating-button.label': '生成を停止',
  'ai-mate.chat-input.store-user-messages.label': '回答の質を高めるためにこのメッセージを記録する',
  'ai-mate.chat-input.web-search-button-extended.label': 'Web 検索',
  'ai-mate.chat-input.web-search-button.label': '検索',
  'ai-mate.chat-main-header.back-button.label': '戻る',
  'ai-mate.chat-main-header.copy-agent-link-button.label': 'リンクをコピー',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.body':
    '詳細調査が進行中です。このままチャットを閉じると、バックグラウンドでプロンプトを処理できなくなります。',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.button': 'チャットを閉じる',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.cancel-button': 'キャンセル',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.close-button': '閉じる',
  'ai-mate.chat-main-header.deep-research-confirm-close-chat-modal.title': 'チャットを閉じる',
  'ai-mate.chat-main-header.default-agent-name': 'チャット',
  'ai-mate.chat-main-header.edit-agent-button.label': '編集',
  'ai-mate.chat-main-header.link-copied-to-profile': 'URL をコピーしました',
  'ai-mate.conversation-assistant.finalize-space.space-permissions.copy-option-label': '別のスペースからコピー',
  'ai-mate.conversation-assistant.finalize-space.space-permissions.default-option-label': '既定',
  'ai-mate.conversation-assistant.finalize-space.space-permissions.private-option-label': '自分にのみ表示',
  'ai-mate.conversation-list-refresh.search-input-placeholder.label': 'すべてのチャットを検索...',
  'ai-mate.conversation-list-refresh.title.label': 'すべてのチャット',
  'ai-mate.feedback-collector.share-thoughts-label': '要約',
  'ai-mate.feedback-collector.share-thoughts-placeholder': '具体的な内容をご入力ください',
  'ai-mate.footer.debug-button.tooltip': 'デバッグ',
  'ai-mate.footer.footer-message': 'AI を使用します。結果を確認してください。',
  'ai-mate.footer.local-frontend-components.insert-agent-id-label': 'agentId を入力してください',
  'ai-mate.footer.rovo-beta-label': 'ベータ版',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.footer.rovo-branding-label-updated': 'Rovo {logo}',
  'ai-mate.local-frontend-components.agent-embed-button-label': 'エージェントの組み込み',
  'ai-mate.local-frontend-components.call-an-api-button-label': 'API を呼び出す',
  'ai-mate.local-frontend-components.close-label': 'ローカル コンポーネントを閉じる',
  'ai-mate.local-frontend-components.close-simulated-fullscreen-button-label': 'シミュレートされた全画面表示を閉じる',
  'ai-mate.local-frontend-components.create-edit-button-label': 'エージェントを作成/編集',
  'ai-mate.local-frontend-components.create-release-button-label': 'Jira リリースを作成',
  'ai-mate.local-frontend-components.modal-title': 'ローカル コンポーネント',
  'ai-mate.local-frontend-components.pubsub-events-button-label': 'Pub/Sub イベント',
  'ai-mate.local-frontend-components.simulated-fullscreen-button-label': '全画面表示をシミュレート',
  'ai-mate.placeholder.c-suite.alignment': '部門横断型調整ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.c-suite.executive-decisions':
    'ドキュメントを使用して経営幹部の意思決定をリアルタイムで追跡するよう Rovo に頼む',
  'ai-mate.placeholder.c-suite.executive-summary': 'ボードのエグゼクティブ サマリーを作成するよう Rovo に頼む',
  'ai-mate.placeholder.c-suite.market-expansion': '総合的な市場拡大計画の草案を作成するよう Rovo に頼む',
  'ai-mate.placeholder.c-suite.strategy':
    'ビジョン、ミッション、最優先事項を含む企業戦略ページの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.c-suite.three-year-vision': '3 か年ビジョンのホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.customer-service.escalation': 'エスカレーション プロセスを文書化するよう Rovo に頼む',
  'ai-mate.placeholder.customer-service.faq': 'FAQ ページを作成するよう Rovo に頼む',
  'ai-mate.placeholder.customer-service.incident-tracker':
    'ドキュメントを使用してインシデントのリアルタイム トラッカーを作成するよう Rovo に頼む',
  'ai-mate.placeholder.customer-service.knowledge-base':
    '解決に役立つナレッジ ベース記事の下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.customer-service.script': 'サポート スクリプトの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.customer-service.workflow': 'ワークフロー改善ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.data-science.data-cleaning': '実施したデータ クリーンアップ手順を文書化するよう Rovo に頼む',
  'ai-mate.placeholder.data-science.exploration':
    'コラボレーション向けのデータ探索ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.data-science.pipeline-diagram':
    'ホワイトボードでデータ パイプラインを図表化するよう Rovo に頼む',
  'ai-mate.placeholder.data-science.project-analysis': 'プロジェクト分析の要約の下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.data-science.research-template': '再利用可能な調査テンプレートを作成するよう Rovo に頼む',
  'ai-mate.placeholder.data-science.whiteboard': 'ビジュアル ホワイトボード モデルを作成するよう Rovo に頼む',
  'ai-mate.placeholder.design.decision': 'デザイン意思決定ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.design.end-to-end-visualization':
    'エンドツーエンドの視覚化ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.design.project-kickoff': 'プロジェクト キックオフ ページの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.design.review': 'コラボレーション向けの設計レビュー ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.design.spec':
    'ユーザー ストーリー、主要なフロー、アクセシビリティ ノートを含む設計仕様テンプレートを作成するよう Rovo に頼む',
  'ai-mate.placeholder.design.voice-tone': '文体とトーンに関するガイドの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.engineering.instrumentation-spec':
    'インストゥルメンテーションの仕様書を作成するよう Rovo に頼む',
  'ai-mate.placeholder.engineering.sprint-planning': 'スプリント計画ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.engineering.standup-notes': 'スタンドアップ ミーティング議事録を作成するよう Rovo に頼む',
  'ai-mate.placeholder.engineering.team-velocity': 'チームのベロシティ レポートの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.engineering.tech-design': '技術設計ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.engineering.write-api-documentation': 'API ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.finance.account-plan': 'アカウント計画の下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.finance.budget-variance':
    'コラボレーション向けの予算差異分析ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.finance.compliance-checklist': 'コンプライアンス チェックリストを作成するよう Rovo に頼む',
  'ai-mate.placeholder.finance.market-trend': '市場動向分析を作成するよう Rovo に頼む',
  'ai-mate.placeholder.finance.quarterly-outcomes':
    '主要な取引、リスク、アクションをまとめた四半期単位の成果ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.finance.quarterly-planning': '四半期計画ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.generic.brainstorm': 'ブレーンストーミング ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.generic.checklist': 'チェックリストを作成するよう Rovo に頼む',
  'ai-mate.placeholder.generic.decision-doc': '意思決定ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.generic.meeting-notes': 'ミーティング議事録の下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.generic.project-overview': 'プロジェクト概要ページの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.generic.tech-docs': '技術ドキュメントの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.hr.company-policy': '新しい企業ポリシー ページの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.hr.faq': '人事に関するよくある問い合わせの FAQ ページを作成するよう Rovo に頼む',
  'ai-mate.placeholder.hr.interview-notes': 'リアルタイム文書でインタビューのメモを作成するよう Rovo に頼む',
  'ai-mate.placeholder.hr.interview-process': 'インタビュー プロセス改善ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.hr.performance-template':
    'パフォーマンス レビューを文書化するためのテンプレートの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.hr.quarterly-review': '四半期ごとの共同人事戦略レビューを作成するよう Rovo に頼む',
  'ai-mate.placeholder.it.infrastructure-upgrade':
    'インフラストラクチャのアップグレードに関するブレーンストーミングを作成するよう Rovo に頼む',
  'ai-mate.placeholder.it.network-diagram': 'ホワイトボードでネットワーク アーキテクチャを図表化するよう Rovo に頼む',
  'ai-mate.placeholder.it.onboarding-checklist':
    '新入社員の受け入れに必要なオンボーディング チェックリストを作成するよう Rovo に頼む',
  'ai-mate.placeholder.it.policy-procedure': '新しい IT ポリシー/手順の下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.it.tech-docs': '技術ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.it.troubleshooting-guide': 'トラブルシューティング ガイドの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.legal.compliance': '新しいコンプライアンス ポリシーの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.legal.compliance-checklist': 'コンプライアンス チェックリストを作成するよう Rovo に頼む',
  'ai-mate.placeholder.legal.compliance-review':
    'コンプライアンス レビューの計画ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.legal.contract-diagram':
    'ホワイトボードを使用して契約レビューと承認プロセスを図表化するよう Rovo に頼む',
  'ai-mate.placeholder.legal.contract-negotiations':
    'ドキュメントを使用して契約交渉のリアルタイム トラッカーを作成するよう Rovo に頼む',
  'ai-mate.placeholder.legal.risk-assessment':
    'ホワイトボードでリスク評価ブレーンストーミングを作成するよう Rovo に頼む',
  'ai-mate.placeholder.marketing.battle-card': '提案内容を示す競合バトル カードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.marketing.buyer-personas': '詳細な購入者のペルソナの下書きを 3 つ作成するよう Rovo に頼む',
  'ai-mate.placeholder.marketing.campaign':
    'キャンペーンに関するブレーンストーミング ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.marketing.gtm': 'GTM 計画ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.marketing.press-release': '発売に向けたプレス リリースを作成するよう Rovo に頼む',
  'ai-mate.placeholder.marketing.reactivation-campaign':
    'ホワイトボードを使用して再活性化キャンペーンに関するブレーンストーミングを作成するよう Rovo に頼む',
  'ai-mate.placeholder.operations.compliance': 'コンプライアンス チェックリストを作成するよう Rovo に頼む',
  'ai-mate.placeholder.operations.incident-log': 'インシデントのリアルタイム ログの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.operations.process-improvement': 'プロセス改善ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.operations.procurement': '調達プロセスのホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.operations.review': '運用レビューの要約の下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.operations.sop': 'SOP ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.product.prd': '製品要件ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.product.prioritization': '優先順位付けフレームワークのホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.product.quarterly-goals': '四半期単位のゴール ステータス最新情報を作成するよう Rovo に頼む',
  'ai-mate.placeholder.product.retro': '製品ローンチのふりかえりホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.product.roadmap': '製品ロードマップのタイムラインを作成するよう Rovo に頼む',
  'ai-mate.placeholder.product.strategy': '戦略計画ページを作成するよう Rovo に頼む',
  'ai-mate.placeholder.program.communication': '関係者のコミュニケーション計画を作成するよう Rovo に頼む',
  'ai-mate.placeholder.program.decisions': '最近の重要な決定事項とアクションを要約するよう Rovo に頼む',
  'ai-mate.placeholder.program.risk-brainstorm':
    'ホワイトボードでプログラム リスクに関するブレーンストーミングを作成するよう Rovo に頼む',
  'ai-mate.placeholder.program.risk-register': 'コラボレーション向けのリスク登録簿の下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.program.roadmap': 'ロードマップ計画ドキュメントを作成するよう Rovo に頼む',
  'ai-mate.placeholder.program.status-report': 'プログラム ステータス レポートの下書きを作成するよう Rovo に頼む',
  'ai-mate.placeholder.sales.account-history': 'アカウント履歴を要約するよう Rovo に頼む',
  'ai-mate.placeholder.sales.discovery-questions':
    '最初の連絡で使用する状況把握のための質問の下書きを 10 - 15 個作成するよう Rovo に頼む',
  'ai-mate.placeholder.sales.ebc-agenda': 'EBC アジェンダを作成するよう Rovo に頼む',
  'ai-mate.placeholder.sales.enablement':
    'イネーブルメントに関するブレーンストーミング ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.sales.pipeline-visualization': 'パイプラインの視覚化ホワイトボードを作成するよう Rovo に頼む',
  'ai-mate.placeholder.sales.playbook': 'セールス プレイブック ページの下書きを作成するよう Rovo に頼む',
  'ai-mate.prompt-cards.more-ideas': 'さらにアイデアを表示',
  'ai-mate.prompt-cards.show-less': '表示を減らす',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': '確認できませんでした。しばらくしてからもう一度お試しください。',
  'ai-mate.pubsub-listener.forge-auth-success-message': '確認できました。プロンプトを再送信してください。',
  'ai-mate.sidebar.agents-icon.text': 'エージェント',
  'ai-mate.sidebar.agents-icon.tooltip': 'Rovo エージェントを参照',
  'ai-mate.sidebar.chat-icon.text': 'チャット',
  'ai-mate.sidebar.chat-icon.tooltip': 'Rovo とチャット',
  'ai-mate.sidebar.debug-mode-icon.tooltip': 'デバッグ',
  'ai-mate.sidebar.get-help-icon.tooltip': 'サポート',
  'ai-mate.sidebar.give-feedback-icon.tooltip': 'フィードバックを送信',
  'ai-mate.sidebar.history-icon.text': '履歴',
  'ai-mate.sidebar.history-icon.tooltip': 'チャット履歴を表示',
  'ai-mate.smart-create.title': '今日は何を作成しますか?',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-description':
    'ファイルの検証中にエラーが発生しました。もう一度お試しください。',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-title': 'ファイルの検証に失敗しました',
  'ai-mate.upload-files-to-conversation.file-invalid-icon-label': '無効なファイル',
  'ai-mate.upload-files-to-conversation.file-rai-policy-violation':
    'このファイルはアトラシアンの利用規定に準拠していない可能性があります。別のファイルをお試しください。',
  'ai-mate.upload-files-to-conversation.invalid-files-description':
    '{count, plural, other {次のファイルはサポートされていません: "{fileNames}" 理由: {reasons}}}',
  'ai-mate.upload-files-to-conversation.invalid-files-title':
    '{count, plural, other {サポートされていないファイル タイプが {count,number} 件あります}}',
  'ai-mate.upload-files-to-conversation.unknown-error':
    'ファイルのアップロード中にエラーが発生しました。もう一度お試しください。',
  'ai-mate.upload-files-to-conversation.unsupported-file': 'サポートされていないファイル タイプです',
  'ai-mate.upload-files-to-conversation.validation-error-file-name-missing': 'ファイル名がありません',
  'ai-mate.upload-files-to-conversation.validation-error-file-too-large': 'ファイル サイズが大きすぎます',
  'ai-mate.upload-files-to-conversation.validation-error-invalid-content-type':
    'ファイル タイプがサポートされていません',
  'ai-mate.upload-files-to-conversation.validation-error-missing-error-code': '検証結果が不明です',
  'ai-mate.upload-files-to-conversation.validation-error-not-found': '検証結果が見つかりません',
  'ai-mate.upload-files-to-conversation.validation-error-unknown-error': 'ファイルの検証に失敗しました (原因不明)',
  'chat-history.deep-research-rate-limit-warning': '24 時間後にもう一度お試しください。',
  'chat-history.deep-research-rate-limit-warning-description':
    '詳細調査のレート制限を超えました。24 時間後にもう一度お試しください。',
  'chat-history.rate-limit-warning': '{secondsRemaining, plural, other {{secondsRemaining,number} 秒お待ちください}}',
  'chat-history.rate-limit-warning-description': 'メッセージの送信が速すぎます。しばらくお待ちください。',
  'chatHistory.storeAssistant.badResponseLabel': '悪い返答',
  'chatHistory.storeAssistant.copyResponseLabel': 'コピー',
  'chatHistory.storeAssistant.debugLabel': 'デバッグ対応',
  'chatHistory.storeAssistant.goodResponseLabel': 'よい返答',
  'rovo-chat.agent-debug-modal.action-container.expand-label': '展開/折りたたむ',
  'rovo-chat.agent-debug-modal.action-container.input-label': '入力',
  'rovo-chat.agent-debug-modal.action-container.lines-rendered-label':
    '{total, plural, other {{total} 行中 {current} 行を表示中}}',
  'rovo-chat.agent-debug-modal.action-container.output-label': '出力',
  'rovo-chat.agent-debug-modal.action-container.show-more-label': '表示を増やす',
  'rovo-chat.agent-debug-modal.cancel': '閉じる',
  'rovo-chat.agent-debug-modal.copy-all-button': 'すべてコピー',
  'rovo-chat.agent-debug-modal.copy-all-tooltip': 'クリップボードにコピーしました',
  'rovo-chat.agent-debug-modal.error-message': 'デバッグ ログの取得中にエラーが発生しました',
  'rovo-chat.agent-debug-modal.header-text': 'レスポンス詳細',
  'rovo-chat.agent-debug-modal.header-text-description':
    'この対応に関するサポート チケットを登録する場合、これらの詳細をサポート チームに提供できます。',
  'rovo-chat.agent-debug-modal.message-info.agent-id-label': 'エージェント ID',
  'rovo-chat.agent-debug-modal.message-info.agent-label': 'エージェント',
  'rovo-chat.agent-debug-modal.message-info.copy-to-clipboard-label': 'コピー',
  'rovo-chat.agent-debug-modal.message-info.copy-to-clipboard-tooltip': 'クリップボードにコピー',
  'rovo-chat.agent-debug-modal.message-info.default-scenario-label': '既定のシナリオ',
  'rovo-chat.agent-debug-modal.message-info.scenario-label': 'シナリオ',
  'rovo-chat.agent-debug-modal.message-info.trace-id-label': 'リクエスト ID',
  'rovo-chat.agent-debug-modal.message-not-found-message': '会話内のメッセージが見つかりませんでした',
  'rovo-chat.agent-debug-modal.skills-description': '回答を提供するためにエージェントが使用するスキル。',
  'rovo-chat.agent-debug-modal.skills-label': '使用されるスキル',
  'rovo-chat.agent-debug-modal.title': 'デバッグ対応',
  'rovo-chat.agent-debug-modal.tools-fetching-error-message': 'ツールの取得中にエラーが発生しました',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': 'このコンテキストを使用',
  'rovo-chat.data-sculptor-modal.cancel': 'キャンセル',
  'rovo-chat.data-sculptor-modal.no-data': 'データなし',
  'rovo-chat.data-sculptor-modal.title': '分析',
  'rovo-chat.file-upload-button.label': 'アップロードするファイル',
  'rovo-chat.file-upload-button.max-files-label':
    '{maxFiles, plural, other {ファイル数の上限 {maxFiles,number} 件に達しました}}',
  'rovo-chat.store-assistant.beta-features-message': '提供した回答ではベータ版の機能を利用しています。',
  'rovo-chat.store-assistant.beta-lozenge': 'ベータ版',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': 'ページに挿入',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': '挿入',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': '作業項目に挿入',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': '選択内容を置換',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    '現在のコンテキストではこの機能はサポートされません。ページでテキストを選択するか、書き込むか、編集してみてください。',
  'rovo-chat.store-assistant.sources-title': 'ソース:',
  'smart-creation.preview.add-to-space-popup.cancel-button': 'キャンセル',
  'smart-creation.preview.add-to-space-popup.confirm-button': '追加',
  'smart-creation.preview.add-to-space-popup.content-type-buttons-label': 'タイプを選択',
  'smart-creation.preview.add-to-space-popup.content-type-live-doc': 'リアルタイム文書',
  'smart-creation.preview.add-to-space-popup.content-type-page': 'ページ',
  'smart-creation.preview.add-to-space-popup.error-flag.description':
    'Rovo チャットを再度開いて、もう一度お試しください。',
  'smart-creation.preview.add-to-space-popup.error-flag.title': 'このオブジェクトをスペースに追加できませんでした',
  'smart-creation.preview.add-to-space-popup.no-parent-error': '親を選択してください',
  'smart-creation.preview.add-to-space-popup.no-space-error': 'スペースを選択してください',
  'smart-creation.preview.add-to-space-popup.parent-label': '親',
  'smart-creation.preview.add-to-space-popup.restrict-access-label': '非公開に設定',
  'smart-creation.preview.add-to-space-popup.select-space-label': 'スペースを選択',
  'smart-creation.preview.add-to-space-popup.title.heading': 'Confluence スペースに追加する',
  'smart-creation.preview.addToSpaceButton.closeIconLabel': '閉じる',
  'smart-creation.preview.addToSpaceButton.v2': 'Confluence に追加',
  'smart-creation.preview.create-a-space-popup.title': 'スペースを作成',
  'smart-creation.preview.createAllButton': '{projectName} ですべて作成',
  'smart-creation.preview.createSpaceButton': 'スペースを作成',
  'smart-creation.preview.createSpaceButton.closeIconLabel': '閉じる',
  'smart-creation.preview.error-flag.description':
    'これらの作業項目を作成できませんでした。ページを再読み込みして、もう一度お試しください。',
  'smart-creation.preview.error-flag.title': 'これらの作業項目を作成できませんでした',
  'smart-creation.preview.lozenge': 'プレビュー • 自分のみに公開されます',
};
